import React from "react";
import { Radio } from "antd";
import { Views } from "react-big-calendar";
import { useIntl } from "react-intl";

const SchedulerScopeChanger = (props) => {
  const { calenderView, onChangeView } = props;
  const intl = useIntl();

  return (
    <Radio.Group onChange={onChangeView}>
      <Radio.Button value={Views.DAY}>
        {intl.formatMessage({
          id: "app.scheduling.day",
        })}
      </Radio.Button>
      <Radio.Button value={Views.WEEK}>
        {intl.formatMessage({
          id: "app.scheduling.week",
        })}
      </Radio.Button>
      <Radio.Button value={Views.MONTH}>
        {intl.formatMessage({
          id: "app.scheduling.month",
        })}
      </Radio.Button>
      <Radio.Button value={null}>
        {intl.formatMessage({
          id: "app.events_schedule.table",
        })}
      </Radio.Button>
    </Radio.Group>
  );
};

export default SchedulerScopeChanger;
